//
//
//
//
//
//
//
//
//

export default {
  name: 'back_to_top',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};